// import io from "socket.io-client";

export const LENDER_URL = process.env.REACT_APP_LENDER_URL;
// const socket = io(LENDER_URL);
// console.log(socket);
